<template>
  <div v-if="copyAction" class="copy-text-div ri-label" @click="copyCode" >
    <icon icon-name="content_copy" :color="iconColors.copy" size="18px" class="copy-icon" />
    <span class="cta-copy margin-right-xxs">להעתיק</span>
  </div>
  <div v-else class="copy-text-div  ri-label">
    <icon icon-name="check" :color="iconColors.done" weight="bold" size="18px" fill class="copy-icon" />
    <span class="cta-done margin-right-xxs">הועתק</span>
  </div>
</template>

<script>

import Segment from '@/Segment';
import BaseUI from '@riseupil/base-ui';

export default {
  name: 'CopyText',
  components: {
    Icon: BaseUI.Icon,
  },
  data() {
    return {
      copyAction: true,
      iconColors: {
        copy: BaseUI.Colors.riseupBlue,
        done: BaseUI.Colors.riseupGreen,
      },
    };
  },
  props: {
    copyContent: { type: String, required: true },
    copyClickedEvent: { type: String },
  },
  methods: {
    async copyCode() {
      this.copyAction = false;
      Segment.trackUserInteraction(this.copyClickedEvent || 'CopyCode_Clicked');
      await this.$copyText(this.copyContent);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@riseupil/base-ui/src/scss/riseup-colors";

.copy-text-div {
  flex-direction: row;
  display: inline-flex;
  align-items: flex-end;
  cursor: pointer;

  .copy-icon {
    line-height: 20px;
  }

  .cta-copy {
    color: $riseup_blue;
  }

  .cta-done {
    color: $riseup_green;
  }
}
</style>
